// src/components/Administration/Sites/helpers/api.js

// Hitta r�tt API_URL beroende p� bundler och milj�
const API_URL =
  // Vite
  (typeof import.meta !== "undefined" &&
    import.meta?.env?.VITE_API_URL) ||
  // CRA/Webpack
  (typeof process !== "undefined" &&
    process.env?.REACT_APP_API_URL) ||
  // Next.js
  (typeof process !== "undefined" &&
    process.env?.NEXT_PUBLIC_API_URL) ||
  // Global override via <script>
  (typeof window !== "undefined" && window.__API_URL__) ||
  // Fallback: samma origin som frontenden
  (typeof window !== "undefined" ? window.location.origin : null) ||
  // Sista fallback: h�rdkodat
  "http://localhost:5002";

// Hj�lpfunktion f�r att hantera fetch-respons
async function j(res) {
  if (!res.ok) {
    const t = await res.text();
    throw new Error(t || res.statusText);
  }
  return res.json();
}

// API-funktioner
export const listWorkspaces = () =>
  j(
    fetch(`${API_URL}/workspaces`, {
      credentials: "include",
    })
  );

export const createWorkspaceApi = (payload) =>
  j(
    fetch(`${API_URL}/workspaces`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
      body: JSON.stringify(payload),
    })
  );

export const listStructures = () =>
  j(
    fetch(`${API_URL}/structures`, {
      credentials: "include",
    })
  );

export const listUsers = () =>
  j(
    fetch(`${API_URL}/users`, {
      credentials: "include",
    })
  );
